import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AclModule } from '@app/acl/acl.module';
import { ComponentsModule } from '@app/shared/components/components.module';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgRxDataGridModule } from 'ngrx-data-grid';
import { NgrxFormsModule } from 'ngrx-forms';
import { DragAndDropModule, PcsComponentLibraryModule } from 'pcs-component-library';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    NgrxFormsModule,
    FormsModule,
    DirectivesModule,
    NgRxDataGridModule,
    AclModule,
    PcsComponentLibraryModule
  ],
  declarations: [],
  providers: [],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    NgrxFormsModule,
    FormsModule,
    ComponentsModule,
    DirectivesModule,
    TranslateModule,
    PipesModule,
    DragAndDropModule,
    NgRxDataGridModule,
    AclModule,
    PcsComponentLibraryModule
  ]
})
export class SharedModule {
}
